// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

class SearchBoxController {
   $http: angular.IHttpService
   $locale: any
   $location: any
   $q: any
   $scope: any
   $uibModal: any
   $uibModalInstance: any
   acService: AutocompleteService
   appState: AppStateService
   configs: ConfigService
   datepickerService: DatepickerService
   dialogService: DialogService
   events: EventService
   i18n: TranslationService
   menuManagerService: MenuManagerService
   moreFacetsService: MoreFacetsService
   $log: angular.ILogService
   searchScopeService: SearchScopeService
   searchService: SearchService
   constructor($scope: any, appState: any, $location: any, events: any, configs: any, datepickerService: any, $http: any, $locale: any, $q: any, embeddedValues: any, translationService: any, menuManagerService: any, moreFacetsService: any, acService: any, $uibModal: any, dialogService: any, $log: any, searchScopeService: SearchScopeService, searchService: SearchService) {
      this.useEnhancedAutocomplete = this.useEnhancedAutocomplete.bind(this)
      this.getAutocomplete = this.getAutocomplete.bind(this)
      this.toggleAdvanced = this.toggleAdvanced.bind(this)
      this.runSearch = this.runSearch.bind(this)
      this.clearSearch = this.clearSearch.bind(this)
      this.$log = $log
      this.$scope = $scope
      this.appState = appState
      this.$location = $location
      this.events = events
      this.configs = configs
      this.datepickerService = datepickerService
      this.$http = $http
      this.$locale = $locale
      this.$q = $q
      this.menuManagerService = menuManagerService
      this.moreFacetsService = moreFacetsService
      this.acService = acService
      this.$uibModal = $uibModal
      this.dialogService = dialogService
      this.searchScopeService = searchScopeService
      this.searchService = searchService
     
      
      const config = this.configs.data
      this.$scope.search = this.$scope.search || {}
      this.$scope.search.query = this.$scope.search.query  || ''
      this.$scope.search.advanced = false
      this.$scope.round = Math.round
      this.$uibModalInstance = null

      // set configurations
      this.$scope.search.enableNewSearchButton = config.search.enableNewSearchButton
      this.$scope.search.runSearch = _.debounce(this.runSearch, 500, true)
      this.$scope.search.toggleAdvanced = this.toggleAdvanced

      this.$scope.search.useEnhancedAutocomplete = this.useEnhancedAutocomplete
      this.$scope.getAutocomplete = _.debounce(this.getAutocomplete, 250, true)
      this.$scope.deferAutocompleteAbort = null

      this.$scope.embeddedValues = embeddedValues
      this.$scope.clearSearch = this.clearSearch

      this.$scope.search.onEnhancedAutocompleteResponse = this.acService.transformResponse
      this.$scope.search.url = this.acService.getUrl()

      this.$scope.hasSearchScopes = this.searchScopeService.hasSearchScopes 
      this.$scope.isScopeBuilderInit = false

      this.i18n = translationService
      this.$scope.textInformation = {
         textWidth : 0,
         textToMeasure : this.$scope.advancedEnabled ? this.i18n.translations.OPTIONS : ''
      }

      this.useInputFromSSRSearchBox()

      const applyAppState = () => {
         if (_.has(this.appState.params, 'advanced')) {
            this.$scope.search.advanced = true
            delete this.appState.params.advanced
         }
         const q = typeof this.appState.params.q === 'undefined' ? '' : this.appState.params.q 
         this.$scope.search.query = q
         this.$scope.search.journalTitle = this.appState.params.jt || false
         if (_.has(this.appState.params, 'bookMark')) {
            return this.$scope.setWindowTitle(this.i18n.translations.BOOKMARK_RESULT)
         } else if (this.$scope.search.query != null) {
            return this.$scope.setWindowTitle(this.i18n.translations.RESULTS_FOR + `\"${this.$scope.search.query}\"`)
         } else {
            return this.$scope.setWindowTitle('Summon 2.0')
         }
      }

      this.appState.on('apply', applyAppState)

      this.$scope.$on('$destroy', () => {
         return this.appState.off('apply', applyAppState)
      })
   }

   useInputFromSSRSearchBox() {
      if ((window as any).__preserveSearchBox?.value && !this.$scope.search.query) {
         this.$scope.search.query = (window as any).__preserveSearchBox.value;
         delete (window as any).__preserveSearchBox;
       }
   }

   useEnhancedAutocomplete() {
      return this.configs.data.autocomplete.enhancedEnabled
   }

   getAutocomplete(val: any) {

      // Don't autocomplete if not enabled
      if (!this.configs.data.autocomplete.enabled) { return {} }

      const currentClient = this.configs.data.head.client

      this.$scope.deferAutocompleteAbort = this.$q.defer()

      return this.$http.get("/metadata/suggest/suggest", {
         params: {
            prefix: val,
            type: ["/time/event", "/event", "/base/newsevents/news_reported_event", "/base/argumentmaps/morally_disputed_activity", "/book/book_subject", "/education/field_of_study", "/location", "/education/academic", "/common/topic/subject_of", "/medicine", "/base/argumentmaps"],
            type_strict: "should",
            all_types: false
         },
         timeout: this.$scope.deferAutocompleteAbort.promise
      }
      ).then(function(response: any) {
         const whitelistedResults = _.reject(response.data.result, function(item: any) {
            if (currentClient === "vt") {
               return item.name.toLowerCase() === "virginia tech massacre"
            }
         })
         return whitelistedResults.map((item: any) => item.name)
      })
   }

   toggleAdvanced(isScopeBuilderInit = false) {
      this.$scope.isScopeBuilderInit = isScopeBuilderInit
      const additionalClass = isScopeBuilderInit ? ' search-scope' : ''   // add a css class for search-scope
      const isBackdrop = isScopeBuilderInit ? false : true // freeze background in case it is search scope
      this.dialogService.displayModalDialog(this.$scope, 'AdvancedSearchModalCtrl', 'advanced-search', 'advancedSearch/advancedSearch.html', isBackdrop, additionalClass)
   }

   runSearch() {
      this.$scope.newSearchInfo.isNewSearch = false
      this.$scope.viewState.currentView = 'search'

      if (this.$scope.deferAutocompleteAbort) {
         this.$scope.deferAutocompleteAbort.resolve()
      }
      
      return this.searchService.runSearch(this.$scope.search, this.$scope.view)

   }

   clearSearch() { 
      this.$scope.search.query = ''
      return angular.element('.searchBox').focus()
   }


}

SearchBoxController.$inject = ['$scope', 'appStateService', '$location', 'eventService',
   'configService', 'datepickerService', '$http', '$locale', '$q', 'embeddedWidgetValues',
   'translationService', 'menuManagerService', 'moreFacetsService', 'autocompleteService',
   '$uibModal', 'dialogService', '$log', 'searchScopeService', 'searchService']

angular.module('summonApp.controllers')
   .controller('SearchBoxCtrl', SearchBoxController)
